const Sidebar = () => {
  return (
    <div className="w-64 h-screen bg-white-100 ">
      <div className="p-4">
        <h1 className="text-2xl font-bold text-gray-800">Xebrand Company</h1>
        <p className="text-sm text-gray-500">Team - 2 Members</p>
      </div>
      <nav className="mt-8">
        <ul>
          <li className="px-4 py-2 text-gray-700 hover:bg-gray-200 cursor-pointer">
            Dashboard
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
